var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup448(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_448",
    transform: "translate(-735 -604)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_662",
    d: "M0 0H39V39H0z",
    className: "cls-1",
    transform: "translate(735 604)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_447",
    fill: "none",
    stroke: "#748d6f",
    strokeLinecap: "round",
    strokeWidth: "3px",
    transform: "translate(741.213 610.277)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_89",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 11.5,
    className: "cls-1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Line_13",
    d: "M0 0L6.832 6.896",
    transform: "translate(21.455 21.328)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup448);
export default __webpack_public_path__ + "static/media/Group 448.f3cbe32eb6e3a7f240f8a207d6219643.svg";
export { ForwardRef as ReactComponent };